import { render, staticRenderFns } from "./VehiclesView.vue?vue&type=template&id=476e16d2"
import script from "./VehiclesView.vue?vue&type=script&lang=js"
export * from "./VehiclesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports